import { useSetAtom } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { HStack } from '~/components/elements/HStack'
import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'
import {
  type CustomerAttribute,
  useSurveyQueryReferencedCustomerAttributeIds,
} from '~/hooks/useSurveyQuery'

import { dialogInfoAtom } from '../atoms'

export type CommandsCellProps = {
  dataItem: CustomerAttribute
}

export const CommandsCell = ({
  dataItem: customerAttribute,
}: CommandsCellProps) => {
  const { t } = useTranslation()
  const setDialogInfo = useSetAtom(dialogInfoAtom)
  const referencedCustomerAttributeIds =
    useSurveyQueryReferencedCustomerAttributeIds()
  const idDisabledDeleteButton = React.useMemo(
    () => referencedCustomerAttributeIds.includes(customerAttribute.id),
    [customerAttribute.id, referencedCustomerAttributeIds],
  )

  const handleEditButtonClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    setDialogInfo({ dialogType: 'update', customerAttribute })
  }, [customerAttribute, setDialogInfo])

  const handleMoveToGroupButtonClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    setDialogInfo({ dialogType: 'moveToGroup', customerAttribute })
  }, [customerAttribute, setDialogInfo])

  const handleCloneButtonClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    setDialogInfo({ dialogType: 'clone', customerAttribute })
  }, [customerAttribute, setDialogInfo])

  const handleDeleteButtonClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    setDialogInfo({ dialogType: 'delete', customerAttribute })
  }, [customerAttribute, setDialogInfo])

  return (
    <td>
      <HStack backgroundColor="transparent" spacing={1}>
        <StyledButton
          fillMode="outline"
          icon="edit"
          onClick={handleEditButtonClick}
        >
          {t('edit')}
        </StyledButton>

        <StyledButton
          fillMode="outline"
          icon="folder"
          onClick={handleMoveToGroupButtonClick}
        >
          {t('change_definition_group')}
        </StyledButton>

        <StyledButton
          fillMode="outline"
          icon="copy"
          onClick={handleCloneButtonClick}
        >
          {t('duplicate_custom_segment')}
        </StyledButton>

        <StyledButton
          disabled={idDisabledDeleteButton}
          fillMode="outline"
          icon="delete"
          onClick={handleDeleteButtonClick}
        >
          {t('delete')}
        </StyledButton>
      </HStack>
    </td>
  )
}
